import { Link } from "react-router-dom";
import Table, { ITableRow } from "../../components/table/table";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import { applicantsHttpService } from "@myinnsworth/httpServices";
import { format } from "date-fns";

const headers = [
    { name: 'Name' },
    { name: 'Last updates', width: '220px' },
    { name: 'Action', width: '130px' }
];

export default function ClaimantDetails() {
    const [rows, setRows] = useState<Array<ITableRow>>([]);
    const params = useParams();
    const [pageNo, setPageNo] = useState<number>(1);
    const [totalResults, setTotalResults] = useState<number>(0);

    const refreshApplicants = useCallback(async () => {
        try {
            const applicantResults = await applicantsHttpService.searchInstitutions({
                caseSlug: params.slug!,
                pageNo: pageNo
            });
            setTotalResults(applicantResults.total);
            
            setRows(applicantResults.results.map(applicant => {
                return {
                    cells: [
                        applicant.name,
                        format(applicant.lastUpdated, 'dd/MM/yyyy'),
                        <><Link to={`/cases/${params.slug}/claimant-details/${applicant.id}/view/index`} >View</Link> </>
                    ]
                };
            }));
        } catch {}
    }, [params.slug, pageNo]);

    useEffect(() => {
        refreshApplicants();
    }, [refreshApplicants]);

    return (
        <>
            <Table  headers={headers} 
                    rows={rows} 
                    allowPaging={true} 
                    actionIndex={2} 
                    nameIndex={0} 
                    currentPage={pageNo} 
                    resultsPerPage={5} 
                    totalResults={totalResults} 
                    onChangePage={pageNo => setPageNo(pageNo)}
            />
        </>
    )
}